export default __webpack_public_path__ + "static/media/face_heart_yellow.18e5f214.svg";